<template>
  <div class="crm-tabs">
    <v-container fluid>
      <v-btn icon outlined @click.stop="drawer = !drawer">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
      <v-navigation-drawer
        v-model="drawer"
        temporary
        absolute
        color="primary"
        dark
      >
        <v-list dense class="work-list">
          <h2 class="text-center py-8">WorkList</h2>

          <v-list-item
            @click="allTasks"
            v-if="permissions.includes('index_api_admin-panel_crm_tasks')"
          >
            <v-list-item-content>
              <v-list-item-title
                >All Tasks
                <span>( {{ queues.all_tasks_count }} )</span></v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            @click="myTasks"
            v-if="permissions.includes('index_api_admin-panel_crm_tasks')"
          >
            <v-list-item-content>
              <v-list-item-title
                >My Tasks
                <span>( {{ queues.my_tasks_count }} )</span></v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            @click="myTasksInProcess"
            v-if="permissions.includes('index_api_admin-panel_crm_tasks')"
          >
            <v-list-item-content>
              <v-list-item-title
                >My Tasks In Process
                <span
                  >( {{ queues.my_tasks_in_process }} )</span
                ></v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-list v-if="permissions.includes('index_api_admin-panel_crm_tasks')">
          <v-list-group no-action>
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title
                  >Escalations
                  <span
                    >(
                    {{
                      queues.escalation_counts
                        ? queues.escalation_counts.total
                        : "---"
                    }}
                    )</span
                  ></v-list-item-title
                >
              </v-list-item-content>
            </template>

            <v-list-item @click="levelOne">
              <v-list-item-content>
                <v-list-item-title
                  >level one
                  <span
                    >(
                    {{
                      queues.escalation_counts
                        ? queues.escalation_counts.level_one
                        : "---"
                    }}
                    )</span
                  ></v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="levelTwo">
              <v-list-item-content>
                <v-list-item-title
                  >Level Two
                  <span
                    >(
                    {{
                      queues.escalation_counts
                        ? queues.escalation_counts.level_two
                        : "---"
                    }}
                    )</span
                  ></v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="levelZero">
              <v-list-item-content>
                <v-list-item-title
                  >Never Escalated
                  <span
                    >(
                    {{
                      queues.escalation_counts
                        ? queues.escalation_counts.never_escalated
                        : "---"
                    }}
                    )</span
                  ></v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-group
            no-action
            v-if="permissions.includes('index_api_admin-panel_crm_queues')"
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>Queues </v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
              @click="queueFilter(queue)"
              v-for="queue in queues.queues"
              :key="queue.index"
            >
              <v-list-item-content>
                <v-list-item-title
                  >{{ queue.name }}
                  <span>( {{ queue.tasks_count }} )</span></v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>
        <!-- <v-list
          v-if="
            permissions.includes('index_api_admin-panel_crm_multiple-tasks')
          "
          dense
          class="work-list"
        >
          <v-list-item @click="importTasks">
            <v-list-item-content>
              <v-list-item-title>Import Tasks</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list> -->
      </v-navigation-drawer>
      <v-tabs v-model="tab" centered @change="changeTab">
        <v-tab v-for="item in items" :key="item.index">
          {{ item }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <component
          :task_id="task_id"
          :task_serial="task_serial"
          :interaction_serial="interaction_serial"
          :task_interaction="task_interaction"
          :is="components[tab]"
          :queues="queues"
          :timer="timer"
          @changeIt="taskId"
          @taskSerial="taskSerial"
          @interactionSerial="interactionSerial"
          @taskDetails="taskDetails"
          @callToggleChange="setCallToggle"
        ></component>
      </v-tabs-items>
    </v-container>
  </div>
</template>

<script>
import { IndexData } from "@/helpers/apiMethods";
import { mapGetters } from "vuex";

export default {
  name: "crmDetails",
  components: {
    StartCall: () => import("./detailed-components/StartCall"),
    WorkList: () => import("./detailed-components/WorkList"),
    ImportTasks: () => import("./detailed-components/ImportTasks")
  },
  computed: {
    ...mapGetters({
      permissions: "permissions"
    })
  },
  data() {
    return {
      tab: 0,
      items: ["Worklist", "Start Interaction", "Import Tasks"],
      components: ["WorkList", "StartCall", "ImportTasks"],
      task_id: null,
      task_serial: null,
      interaction_serial: null,
      task_interaction: null,
      drawer: null,
      queues: {},
      details: [
        {
          action: "restaurant",
          title: "Dining",
          active: true,
          items: [
            { title: "Breakfast & brunch" },
            { title: "New American" },
            { title: "Sushi" }
          ]
        }
      ],
      timer: {
        seconds: "00",
        minutes: "00",
        hours: "00"
      },
      timingEvent: "",
      callToggle: false
    };
  },
  created() {
    const tabParam = this.components[this.tab];
    this.$router.push(`/crm/${tabParam}`);
    this.taskId();
    this.taskSerial();
    this.interactionSerial();
    this.taskDetails();
    this.indexQueues();
  },
  methods: {
    allTasks() {
      this.$router.push("/crm/WorkList");
    },
    myTasks() {
      this.$router.push("/crm/WorkList?my_queue");
    },
    importTasks() {
      this.$router.push("/crm/WorkList/download");
    },
    myTasksInProcess() {
      this.$router.push("/crm/WorkList?in_process=mine");
    },
    levelZero() {
      this.$router.push("/crm/WorkList?escalated=never");
    },
    levelOne() {
      this.$router.push("/crm/WorkList?escalated=one");
    },
    levelTwo() {
      this.$router.push("/crm/WorkList?escalated=two");
    },
    queueFilter(queue) {
      this.$router.push(`/crm/WorkList?in_queues=${queue.id}`);
    },
    indexQueues() {
      IndexData({ reqName: "/crm/queues" })
        .then(res => {
          const data = res.data;
          this.queues = data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    changeTab() {
      const tabParam = this.components[this.tab];
      this.$router.push(`/crm/${tabParam}`);
      // tab = tab.toLowerCase().replace(" ", "-");
      // this.$router.replace({
      //   name: "crmDetails",
      //   params: {
      //     tab: tab
      //   }
      // });
    },
    taskId(data) {
      this.task_id = data;
    },
    taskSerial(data) {
      this.task_serial = data;
    },
    interactionSerial(data) {
      this.interaction_serial = data;
    },
    taskDetails(data) {
      this.task_interaction = data;
    },
    formalizeTimerField(currentFieldVal) {
      return currentFieldVal <= 9
        ? "0" + currentFieldVal
        : currentFieldVal.toString();
    },
    resetTimer() {
      this.timer.seconds = "00";
      this.timer.minutes = "00";
      this.timer.hours = "00";
      this.timingEvent = "";
    },
    setCallToggle(newVal) {
      this.callToggle = newVal;
    }
  },
  watch: {
    $route: {
      handler({ params }) {
        if (params.tab) {
          let index = this.components.indexOf(params.tab);
          this.tab = index;
        }
      },
      immediate: true
    },
    callToggle: {
      handler(newVal) {
        if (!newVal) {
          this.timingEvent = setInterval(() => {
            const parsedTimer = {};
            Object.keys(this.timer).forEach(key => {
              parsedTimer[key] = Number(this.timer[key]);
            });

            if (parsedTimer.seconds === 59) {
              this.timer.seconds = "00";
              if (parsedTimer.minutes === 59) {
                this.timer.minutes = "00";
                this.timer.hours = this.formalizeTimerField(
                  parsedTimer.hours + 1
                );
              } else {
                this.timer.minutes = this.formalizeTimerField(
                  parsedTimer.minutes + 1
                );
              }
            } else {
              this.timer.seconds = this.formalizeTimerField(
                parsedTimer.seconds + 1
              );
            }
          }, 1000);
        } else if (this.timingEvent) {
          clearInterval(this.timingEvent);
          this.resetTimer();
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped></style>
